import React, { FC } from "react";
import NcImage from "shared/NcImage/NcImage";
import { Link } from "react-router-dom";
import ButtonCircle from "shared/Button/ButtonCircle";
import Company1 from "images/avatars/Image-1.png";
import { StarIcon } from "@heroicons/react/24/solid";
import Rating from '@mui/material/Rating';
import Cover from "images/videoImg.jpeg";
import Input from "shared/Input/Input";

export interface CardCategory2Props {
  className?: string;
  ratioClass?: string;
  bgClass?: string;
  featuredImage?: string;
  name?: string;
  desc?: string;
}

const CardCategory2: FC<CardCategory2Props> = ({
  className = "",
  ratioClass = "aspect-w-1 aspect-h-1",
  bgClass = "bg-orange-50",
  featuredImage = ".",
  name,
  desc,
}) => {
  return (
    <div

      className={`nc-CardCategory2 ${className}`}
      data-nc-id="CardCategory2"
    >
      <div
      // className={`flex-1 relative w-full h-fit rounded-2xl group`}
      >
        <div className="bg-gray-100 p-3">

          <div className="bg-white w-full p-4">

            <div className="w-full flex justify-between">
              <div className="flex items-center">
                <div className="w-14 h-14 object-fill bg-contain rounded-full"
                  style={{
                    backgroundImage: `url(${Company1})`
                  }}
                >

                </div>
                <div className="ml-6">
                  <div className="flex flex-col">
                    <div className="flex items-center">
                      <span className="text-lg">Anna Sthesia</span>
                      <span className="text-sm ml-2">Add new post</span>
                    </div>
                    <div>
                      <span className="text-sm text-[#2d867b]">Just Now</span>
                    </div>
                  </div>

                </div>

              </div>
              <div className="cursor-pointer">
                <img className="text-4xl text-left mr-1 mt-2" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPElEQVR4nGNgGAWjYBQMT+DNwMDwhIGB4TEDA4MnBeI4AUjhfyh+RIH4wFngCdUEUuxBgfgoGAWjYNgAAIMDJKaeed9aAAAAAElFTkSuQmCC" />

              </div>


            </div>

            <div className="mt-5">
              <span className="text-sm text-justify">Get Expert Answers to Your Farming Questions such as Green Farming, Modern Farming, Agri Technology, Sustainable Agriculture, Regenerative Agriculture and many more.</span>

            </div>

            <div className="flex w-full flex-wrap mt-3">
              {
                [1, 2, 3,].map((item: any, index: any) => {
                  return (
                    <>
                      <div className={`${(index) % 3 === 0 ? "w-full" : "w-1/2"}  p-1`}>
                        <img
                          alt="gallery"
                          className="block h-full w-full  object-cover object-center"
                          src="https://tecdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp" />
                      </div>

                    </>
                  )
                })
              }
              {/* <div className="w-full p-1">
                <img
                  alt="gallery"
                  className="block h-full w-full  object-cover object-center"
                  src="https://tecdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp" />
              </div>
              <div className="w-1/2 p-1">
                <img
                  alt="gallery"
                  className="block h-full w-full object-cover object-center"
                  src="https://tecdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(70).webp" />
              </div>
              <div className="w-1/2 p-1">
                <img
                  alt="gallery"
                  className="block h-full w-full object-cover object-center"
                  src="https://tecdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(72).webp" />
              </div> */}

            </div>

            <div className="flex mt-4 items-center">

              <img className="w-6 h-6 text-left mr-2 cursor-pointer" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAANPklEQVR4nNVbC1xUZRY/M8MwPObFPABfW5pmKy4pWrraZm1ampWlKYrIUxChJDTRtjYflaXlr9qs7W2ZlWW6Ze9yl1LRoBRLKzGzLEkrSyTBIp3T75x7v8tlGIa5wwyy3+93fgwz9373nP/3ned3LkD4RxcAmAQAtwHAOgD4CAC+BYBfAQBlOg4ABwBgOwCsla+9Vr73/27oAGAIACwHgM9UQgZL1QBwDwAMlefutMMGAHMA4Eu1ALpIMxq7DcHo5Ey0XLQYbWMfwbjUV9CR9iY6szajM3MTf46b9DLaLv83mi9cgNHJGWjsOhh1xlhvMPYCwGwAiINONOwAcDsA/CIY1ce4Mbp/GlrHPIjOzM3oyt+J7qK9GF98ABNKDmPCjUcwYe5RTJx3jIk+83clh/kautaVtxOdGZvROvpfGJU0GfXRTjUQdQCwWH72aRt6ACgEgJ8EY7Rq1lH3oDN7C7pnfoYJJTWYWFqLifPqgqPSWkwo+Q7dBZ/ybrFcchcaE1PUQNCz82VeOnT0BYByRfDEFLRd8Ti6cj/kFWyX0H7AiJ/1NT+DVMWYOFANxFYA6NNRwk8T2522uuXvd6IztxLji78JiaDnLDqOVz7ciHnPe3DmCx6cscaDU1aexEtX/Ib9FtfzNQnF36ArtxItIxYxDyq1SA+n4AYAeECgbjrrMnSkvYPxRV+EbMXPvaMer3sJcda61in72VM4bPkJ7DqvFuOL9qIj7W2M7HmJejcsD4dKRAPAy2zVDZFoHjYPXbkVmDD7cEi3ec6zp/wKr6bc507hoKUNmDD7e96BscNKEfQRAgSKN0yhEt4EAG+x8CaLh/TPPWNXWPQ8f40nYAAEpa48iX1uqWOerKMfIB4FCK8CQGR7hY8AgA2s79EOtF/9DLoL94TewMl08f2/agaAaOaLHhy4pAHjC/eg7aqVqDPZBAjr26sO90krb/XYx63C+Ou+CJvwTPPr8LIVv+GsNuyALyLbkXxHPdsk+7inURdp8cggUBQZ1MjmCfRGjt7cM8O38t7U/7Z6nPr0Sc0gkMc445ZfeJeSOqhsAnkuTeNsOUFB8/Cb0D3jkw4TXk2D7mrArNWBG0Yicpd0r7tgl2QYm1xkby3urkJydaPRSda+uCa8ws79CSO7D0VdZCxGnnkxOlJfUX7rMr8Ohyw7ETAQ5Cb53tJaDppMPUeqg6WA7EEhGz1zIvt51/SPMHFuGCI7FVGI2yzp0ek4wFJf02VeHZ6/9ARmteEqC9d6lHsS5nyPzqlvoz7GJebOa0t4BwAcoYuJAXdeFbryq8IqPIW3+ig7M7jy6dV464LFaDAYEPQGjv+9r2cgljW0CsTkp042u95duJezUBmAI20lUEtEUuPK+QCdWVvRXVgdVgBiUvKZuZGjLsUTjchUMLOIv4sZkNPqfQTE4KUNOOHx3zFvjQeL1npwylMnsfeC482vZVWoVOcOi1oTPg4AjtFFtiseRXfeDnRmbeEVCpfwjqnvoE5vwIiICNy+c7cCwIbX3mJmI7v/VfOcSbfVsx2gqLLvouNK7mAb85AAoLa1ekKptPrnMWIkPFFCyaHwAFB6jJ9Fz6QVF8ITvbzhDQmAMy7SPC+FyEId0lcJdTiGrukforHLIAFCibfwOgDYw7o/8m5051c1AXDjT2EBgEJqep7dHocHv/uxGQB3L79PVoFszfNOevJ3BYCCF5oMIu1ksmsyAJ97l9d6gk5fS6klFTOc2eVNAHDlJrTCu4uq0WDpysyQsGrhiWYWXse/Ubqrde6u8+vw8ocaOTymv+odR9UpVfpMNcam4Uz/7+328c+z1RfCE4U66Ym//ks0xJ3FTCSfOwDr6htbADD4vPP5d3U8EBLgCz7FqH6TBABL1fL3cmRt+YgEFsZPAYDrdqETPsJ1DjOQlNQfvzn4fQvhv635AfV6PepNFq4ThhT8G2rQOnqFAOBNIbybvjDYe3rI7am3P6tAaesqQNVefyVtg/1MdEze0CS8u59f4YmKS+bwNVHnXBNy1ZPUYAvGTXjppC2zTIkHxkp1vYHomr69mfCSEfyx1QmDqfO3JryWOXTGaDT1Gsn2SisIrjxJxR2p68cLd7iQJqUyNpeivQHw4wYFQ2NGVPskb8ZTBg1udeWDAVNnjEFXdrk2O1BUjbFDiincPiWfQHH5CM0jFiroqCl+1oF2A+BL4PYQ2YkJ10rGzNRrlDY7MOtrNF+4UPD2GMhZEvtlSny8AXAXft5ikrjUV5lOFwBEtJPELtAEwOxD6Jj2P3Skb6wUNmAfByTj13Ch0xsAV96OTgkAuU+pSGvSBAB5Flm2/QAQBaLG75j6Njqzt7YAgL7zjgU6AwCHfjjKc1NgowmA0p/RMfVdqnRRyYxkh0aayJnxHjqzmrtAxQ7c8G2nA2D/gRqeO8LRW6MnqEVnxvuCt99BlL4c6RsVAKgOKIFSJqlBwe5OB0DFh1VSwvSnC4MAoEzw1gjicNMx5Q1FBXQmKyrf+VCDzgDA2vWv8NzRSanaVSDtTcHbUQLgIP0TN3GdYgT15i5SpjbhRZU7/KpTAbD07nt5bvMF/9BsBOMmrhe8HSQAttE/1jEr0JUruUFRPbFeem+TN8itVPKCzgDAtZPSpEW6+hnNbtA29mHBWyUBsIqRHD5fyQSj+o7jC2KHlDQ3hvIJcGcAoGevPjy3K297EIHQrYK3NQTAP1mX/pKuhMIkOEdZvcc0jwlyKtgWnG4APt69T3KB5i6as1UKhaMH5Aje7iQArpGSoRQlGaKjJX5AbHzLyLCoWjMAu6rrmGp++LXdwjc0Is6/eYlkAPunBZUMGbtK9QYAmCBK4ad0BiM6ppXJnmAz6qPiZB1b7QVCedAAtBeE4w0e3HfgF+ze40yJt/HPBZUO0wGMzFs3EQ5Tfx5aL7uPQ18S1HT2lRLKyZktdoE3AClJD/ok7+wtqf9AfH/rl80A0UoLFt+v1BoS/dQqfOr/DTVqA0gpgDKW0ZdRf56oGELq8JLUIIFb2UIBAFHvPv2CBuGJVa+h2Syd/1Mzlrbtf4zPC6OTJqOvU+NkTixMNnRkvq+ogcHaXfK1Ixb6BcAf0bEUXWsftxoNtjMCuqctovNDzatf+HmzGAcALvAuje+gH+gYSZTFyTXydos7S2pq9AIgwtWvTeEp9xbXMwiO3kELTr2CMYMKuC1Gm+Xfy8d8VPKX5/rK10FpkeQNBvCJMAubUcaeQIoTbmoBQGvU7OEzdrV5fdv0mtR+p9Hi87Yv3CO58OmVaOw2VABAh0Athk3kBRQBiuoQbX9GP8qu5Ab+mHVmbGq5Au0AQepE26ddeDoTzP9ErmlUcR8jgI5kqadTAGhlzCNhqXTtyt2mVIjFkRLpnq90WR0uh7pzLBgiFaGjMJHIUY4jjuEA4C7wM2IA4Dth+KjHlwOjCS9y07Ov8LgFCNnlrHNh6RYNYNWpR0hd1yCvptL9o3Lc43fkCo/AW1pG0nLx7dIk+gie0B8I0m6oCFn3aCC6TjaCQvVmfBDv6e8qdszXoaivQYeGr/OW7zEcnTSpXCegNnYGJyKKi6htgcBEbbTX7w/PjphL/cP7m7a7VymPDJ8I6OS2H2r/CWh0A4CfxZYX0SG5QjEhgRDITlAz5C7YLZXX2tlBTnNQN7rPGqbYgdN3oPmCm4XwJwCgP2gcqQDgAZ0eLSOXNZ0ZZG5CU58rFHVoyyb4pq08H7mo+Ou/wviSQ9IJ1NyfZXBqpc83HuH8nVJYupayVbIxbaofW/3HUBdhEr2CORDkuFVa7Wi0XfmkYhRpJwh1EN5BKZ+dZiKQKIHTmWwe9eFHsEMHAE8xCJEW6fBEdXpEDQf0vWQ0rRh7fnGLvKFjha9C+zWr1V1h1C9shHaOSAD4j9B766jlUsIk6x+5SFXrCYfNFP52KBBk8Gjbj32E23plXsrkLveQDAMAPNGk98XoytmGTtVRGsUNlDkqcXtsPEYnT+OaXVhXnXjIrWCDp9L5DaEUXq0Odyp632MYOqa8jq78j5uscUYZJ1AGaw+vpMjNL1gQcLSDqBOF7hXnDsGv+k50pm9EU5+x6uc9Kne5h22MEzkDZWfmv92CruxtXq01m7ktLersq7jN3l+GJ+7x/r8tXXfmfMDeiTpaVa6uGDpodJd1DEXuwK/I5VZKnsLLP5MaxA6dw10fZC+ozsA9/Xpj4ABkl8uCV3Ifo1d3SmUwfj4UKjFRzq0lIJx9uUPbkfGexCwVWQPw2/6EduZtV3aX5ZKl3oIfk1c94AgvHCNGLq0r7w/StqfV5ncIM8rYUJEQTPQ5t0Iyopy0lPNn/o5+y9vBu8iVux1dmZu475/KWKp4HuVT3SWBJDYdOaLlRKpKrePkOmnbR/WbyC9bUSxBRjAudQM3KtCpNL86O3EdrzK1z5L3oHt8vDpbLb+e22o+31lGihxFkm6eCqTcpTNEepxZmyscUzeulvt31F2d1NM3vLO/PA2tjAQAGCOXoZ4BgA/klTwsW246oqbEi2yJRb6HXpC+CgASw83dH//dcx8kOwqeAAAAAElFTkSuQmCC"></img>
              <span className="text-sm">140 Likes</span>

              <span className="text-sm ml-6">20 Comment</span>

            </div>

            <div className="mt-8 pl-3">
              <div className="space-y-4">

                {
                  [1, 2, 3,].map((item: any, index: any) => {
                    return (
                      <>
                        <div className="w-full flex justify-between">
                          <div className="flex items-start">
                            <div className="w-10 h-10 object-fill bg-contain rounded-full"
                              style={{
                                backgroundImage: `url(${Company1})`
                              }}
                            >

                            </div>
                            <div className="ml-6">


                              <div className="flex flex-col">
                                <div className="flex items-start">
                                  <span className="text-sm">Monty Calo</span>
                                  {/* <span className="text-sm ml-2">Add new post</span> */}
                                </div>
                                <div>
                                  <span className="text-[13px]">Lorem ipsum dolor sit me</span>
                                </div>
                                <div className="flex items-start mt-1 space-x-2">
                                  <span className="text-[13px] text-[#2d867b] cursor-pointer">Like</span>
                                  <span className="text-[13px] text-[#2d867b] cursor-pointer">Reply</span>
                                  <span className="text-[13px] text-[#2d867b] cursor-pointer">Translate</span>
                                  <span className="text-[13px]">5 min</span>
                                </div>
                              </div>


                            </div>

                          </div>



                        </div>

                      </>
                    )
                  })
                }

              </div>





            </div>

            <div className="mt-5">
              <Input className="mt-1.5"
                sizeClass="h-9 px-4 py-3"
                placeholder="Enter Your comment"
              // onChange={(e) => {
              //     setlasttName(e.target.value);
              //     seterrlasttName(false);
              // }}
              // value={lastName}
              />
            </div>



          </div>

          {/* <span className="opacity-0 group-hover:opacity-100 absolute inset-0 bg-black bg-opacity-10 transition-opacity"></span> */}
        </div>
      </div>
      {/* <div className="mt-5 flex-1 text-center">
        <h2 className="text-base sm:text-base text-neutral-900 dark:text-neutral-100 font-semibold">
          {name}
        </h2>
        <span className="block mt-0.5 sm:mt-1.5 text-sm text-neutral-500 dark:text-neutral-400">
          {desc}
        </span>
      </div> */}
    </div>
  );
};

export default CardCategory2;
